import React from 'react';
import sizes from './sizes';

export default React.createContext(sizes.MOBILE);
